<template>
  <BaseDialog
    :is-open="isOpen"
    :title="$t('survey.delete.confirmation')"
    type="basic"
    :description="$t('survey.delete.description')"
    @close="emits('close')"
  >
    <template #dismiss
      ><BaseTextButton color="text" @click="emits('close')">{{
        $t('common.cancel')
      }}</BaseTextButton>
    </template>
    <template #confirm
      ><BaseTextButton color="text" @click="emits('deleteSurvey')">{{
        $t('survey.delete.action')
      }}</BaseTextButton>
    </template>
  </BaseDialog>
</template>
<script lang="ts" setup>
import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'
import BaseDialog from '../../../core/components/base/dialog/BaseDialog.vue'
interface Props {
  isOpen: boolean
}

defineProps<Props>()

const emits = defineEmits<{
  (e: 'close'): void
  (e: 'deleteSurvey'): void
}>()
</script>
